import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CountryShared } from '../../../models/interface/country.interface';
import { MuFieldPositionEnum } from '../../../models/interface/muFieldPosition.enum';
import { MuLayoutService } from '../../../sharedProtos/layout/mu-layout.service';
import { MuToastService } from '../../../sharedServices/mu-toast.service';
import { UtilsService } from '../../../sharedServices/utils.service';
import { Actions } from '../../../types/actions.type';

@Component({
  selector: 'app-mu-form-currency',
  templateUrl: './mu-form-currency.component.html',
  styleUrls: ['./mu-form-currency.component.sass'],
})
export class MuFormCurrencyComponent<ActionType> implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() maxValue: number;
  @Input() showEdit: boolean;
  @Input() toastTitle: string;
  @Input() toastText: string;
  @Input() hideLabel: boolean;
  @Input() hidePlaceholder: boolean;
  @Input() delegateError: boolean;
  @Input() actionList: Actions<ActionType, any>;
  @Input() actionEnter: ActionType;
  @Input() actionClick: ActionType;
  @Input() country: CountryShared;
  @Input() position: MuFieldPositionEnum;
  @Input() notCheckField: boolean;
  @HostBinding('class') baseClass = 'mu-form-currency';
  inputWidth: any;

  constructor(private utilsService: UtilsService, private muToastService: MuToastService, private layoutService: MuLayoutService) {
    /** */
  }

  async ngOnInit(): Promise<void> {
    this.country = await this.layoutService.getCountry();
  }

  /**
   * check field data
   */
  async checkField(): Promise<void> {
    await this.cleanCurrency();
    let newValue = this.formData.get(this.controlName).value;
    newValue = this.utilsService.unformatCurrencyValue(newValue);
    const errors = this.formData.get(this.controlName).errors;
    if (!this.utilsService.isNumeric(newValue) && !this.notCheckField) {
      this.formData.get(this.controlName).setErrors({ invalid: true });
      return environment.guardClause;
    }
    this.formData
      .get(this.controlName)
      .setValue(newValue ? this.utilsService.formatCurrency(newValue, this.country) : '', { emitEvent: false });

    if (this.notCheckField) {
      return environment.guardClause;
    }
    if (this.maxValue && parseFloat(newValue) > this.maxValue) {
      if (this.toastTitle && this.toastText) {
        this.muToastService.showSpecificToast({
          key: 'toast-layout',
          severity: 'error',
          summary: this.toastTitle,
          detail: this.toastText,
          life: environment.toastData.life,
        });
      }
      this.formData.get(this.controlName).updateValueAndValidity();
      if (this.delegateError) {
        this.formData.get(this.controlName).setErrors(errors || { maxValue: this.maxValue });
      } else {
        this.formData.get(this.controlName).setErrors({ invalid: true });
      }
      return environment.guardClause;
    }
    if (!this.delegateError) {
      this.formData.get(this.controlName).setErrors({ invalid: false });
      this.formData.get(this.controlName).updateValueAndValidity();
    }
  }

  /**
   * method to clean currency
   */
  async cleanCurrency(): Promise<void> {
    await this.utilsService.muSleep(1);
    const value = this.formData.get(this.controlName).value;
    this.formData.get(this.controlName).setValue(this.utilsService.cleanCurrency(value), { emitEvent: false });
  }

  /**
   * get width
   * @returns {string | number} response
   */
  get width(): string | number {
    return this.inputWidth ? this.formData?.get(this.controlName)?.value?.length * 10 + '%' : '100%';
  }

  /**
   * on enter action
   */
  onEnterAction(): void {
    this.actionList?.emit(this.actionEnter, null);
  }

  /**
   * on action click
   */
  onActionClick(): void {
    this.actionList?.emit(this.actionClick, null);
  }
}
